import React, { useEffect, useState } from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { getExercises } from '../utils/api'; // Your local database fetch function
import HorizontalScrollbar from './HorizontalScrollbar';

const SearchExercises = ({ setExercises, bodyPart, setBodyPart }) => {
  const [search, setSearch] = useState('');
  const [allExercises, setAllExercises] = useState([]);
  const [bodyParts, setBodyParts] = useState([]);

  // Mapping for Hebrew to English muscle groups
  const bodyPartMapping = {
    הכל: 'all',
    מתיחות: 'Stretching',
    תחתון: 'lower_back',
    חזה: 'Chest',
    גב: 'Back',
    מתח: 'Back',
    רגליים: 'Legs_and_Glutes',
    סקואט: 'Legs_and_Glutes',
    תיאומים: 'Legs',
    צוואר: 'Neck',
    'יד אחורית': 'Triceps_brachii',
    'יד קדמית': 'Arms',
    בטן: 'Abdominal',
    גוף: 'Full_Body',
    עליון: 'Upper_body',
    אכיליס: 'Αnkle',
    כתף: 'Shoulders',
  };

  // Fetch exercises from local database on mount
  useEffect(() => {
    const fetchExercisesData = async () => {
      try {
        const data = await getExercises(); // Fetch from local DB
        setAllExercises(data);
        const uniqueBodyParts = [...new Set(data.map((ex) => ex.muscleGroup))];
        setBodyParts(['all', ...uniqueBodyParts]);
      } catch (error) {
        console.error('Error fetching exercises:', error);
      }
    };
    fetchExercisesData();
  }, []);

  // Handle search input
  const handleSearch = () => {
    if (search) {
      const searchQuery = search.trim().toLowerCase();
      const mappedSearch = bodyPartMapping[searchQuery] || searchQuery;
      const searchedExercises = allExercises.filter((item) => {
        const nameLower = item.name.toLowerCase();
        const muscleGroupLower = item.muscleGroup.toLowerCase();
        const mappedSearchLower = mappedSearch.toLowerCase();
        const matchesName = nameLower.includes(mappedSearchLower);
        const matchesMuscleGroup = muscleGroupLower.includes(mappedSearchLower);
        return matchesName || matchesMuscleGroup;
      });
      setExercises(searchedExercises);
      setSearch('');
    } else {
      setExercises(allExercises);
    }
    window.scrollTo({ top: 1800, left: 100, behavior: 'smooth' });
  };

  // Handle body part selection, including 'all'
  const handleBodyPartChange = (newBodyPart) => {
    setBodyPart(newBodyPart);
    if (newBodyPart === 'all') {
      setExercises(allExercises);
    } else {
      const filteredExercises = allExercises.filter((ex) => ex.muscleGroup === newBodyPart);
      setExercises(filteredExercises);
    }
    window.scrollTo({ top: 1800, left: 100, behavior: 'smooth' });
  };

  return (
    <Stack alignItems="center" mt="37px" justifyContent="center" p="20px">
      <Typography
        fontWeight={600}
        sx={{ fontFamily: 'GveretLevin', fontSize: { lg: '44px', xs: '30px' } }}
        mb="25px"
        textAlign="center"
      >
        מגוון תרגילים מנצחים
      </Typography>
      <Box position="relative" mb="72px">
        <TextField
          height="76px"
          sx={{
            input: { fontWeight: '700', border: 'none', borderRadius: '4px' },
            width: { lg: '1170px', xs: '280px' },
            backgroundColor: '#fff',
            borderRadius: '40px',
            textAlign: 'center',
            direction: 'rtl',
          }}
          value={search}
          onChange={(e) => setSearch(e.target.value.toLowerCase())}
          placeholder="חפש תרגילים"
          type="text"
        />
        <Button
          className="search-btn"
          sx={{
            bgcolor: '#B5A78A',
            color: '#fff',
            textTransform: 'none',
            width: { lg: '173px', xs: '80px' },
            height: '56px',
            position: 'absolute',
            left: '0px',
            fontSize: { lg: '20px', xs: '14px' },
          }}
          onClick={handleSearch}
        >
          חפש
        </Button>
      </Box>
      <Typography
        fontWeight={600}
        sx={{

          fontFamily: 'GveretLevin',
          fontSize: { lg: '44px', xs: '30px', opacity: '0.7' },
        }}
        mb="25px"
        textAlign="center"
      >
        סוגי שרירים
      </Typography>
      <Box width={{ xs: '100%', lg: '100%' }} alignItems="center" justifyContent="center">
        <HorizontalScrollbar
          data={bodyParts}
          setBodyPart={handleBodyPartChange}
          bodyPart={bodyPart}
        />
      </Box>
    </Stack>
  );
};

export default SearchExercises;